var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNumberOfLinesicon = function SvgNumberOfLinesicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.95 3.15H1.05a.35.35 0 0 0-.35.35v.7c0 .193.157.35.35.35h11.9a.35.35 0 0 0 .35-.35v-.7a.35.35 0 0 0-.35-.35Zm0 3.15H1.05a.35.35 0 0 0-.35.35v.7c0 .193.157.35.35.35h11.9a.35.35 0 0 0 .35-.35v-.7a.35.35 0 0 0-.35-.35ZM9.1 10.85H1.05a.35.35 0 0 1-.35-.35v-.7a.35.35 0 0 1 .35-.35H9.1a.35.35 0 0 1 .35.35v.7a.35.35 0 0 1-.35.35Z",
    clipRule: "evenodd"
  })));
};
export default SvgNumberOfLinesicon;